import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { QRCodeSVG } from 'qrcode.react';
import { ConfirmDialog } from './ConfirmDialog';
import { getPlatformName, getPlatformType } from '@/utils/platformUtils';
import { ONELINK_URL } from '@/utils/constants';
import styles from './ExitConfirmDialog.module.scss';

interface ExitConfirmDialogProps {
  visible: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ExitConfirmDialog: React.FC<ExitConfirmDialogProps> = ({ visible, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  // 使用统一的平台工具函数获取品牌名称和二维码 URL
  const brandName = useMemo(() => getPlatformName(), []);
  const qrCodeUrl = useMemo(() => {
    const platform = getPlatformType();
    return ONELINK_URL[platform];
  }, []);

  // 渲染自定义内容体
  const renderContentSlot = () => (
    <div className={styles.contentWrapper}>
      {/* 二维码区域 */}
      <div className={styles.qrcodeSection}>
        <div className={styles.qrcodeContainer}>
          <div className={styles.qrcodeBox}>
            <QRCodeSVG value={qrCodeUrl} size={352} />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <ConfirmDialog
      visible={visible}
      onConfirm={onConfirm}
      onCancel={onCancel}
      title={t('quitApplication.confirmExit', '确认现在退出吗？')}
      subtitle={t('quitApplication.scanToDownload', '{{brandName}}还有可用的手机APP，扫描下方二维码即可下载', {
        brandName,
      })}
      contentSlot={renderContentSlot()}
      confirmText={t('common.confirm', 'Confirm')}
      cancelText={t('common.cancel', 'Cancel')}
      useHorizontalButtons={true}
    />
  );
};
